import React from "react";
import {
  Typography,
  Container,
  Box,
  Divider,
  Link,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <Box 
      component="footer" 
      sx={{ 
        py: 6, 
        textAlign: "center",
        bgcolor: "#f5f5f7"
      }}
    >
      <Container maxWidth="lg">
        <Divider sx={{ mb: 4 }} />
        <Typography variant="body2" color="text.secondary" mb={2}>
          © {new Date().getFullYear()} Tranzcribe. All rights reserved.
        </Typography>
        <Box 
          sx={{ 
            display: "flex", 
            justifyContent: "center", 
            gap: 3 
          }}
        >
          <Link 
            component={RouterLink} 
            to="/privacy-policy" 
            color="text.secondary"
            underline="hover"
            sx={{ fontSize: "0.875rem" }}
          >
            Privacy Policy
          </Link>
          <Link 
            component={RouterLink} 
            to="/terms-of-service" 
            color="text.secondary"
            underline="hover"
            sx={{ fontSize: "0.875rem" }}
          >
            Terms of Service
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 